import { render, staticRenderFns } from "./FastRegister.vue?vue&type=template&id=f490e976&scoped=true&"
import script from "./FastRegister.vue?vue&type=script&lang=js&"
export * from "./FastRegister.vue?vue&type=script&lang=js&"
import style0 from "./FastRegister.vue?vue&type=style&index=0&id=f490e976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f490e976",
  null
  
)

export default component.exports